export const formatStatusLabel = (status) => {
  if (!status) return "";
  const normalized = String(status).toLowerCase();
  if (normalized === "available" || normalized === "active") {
    return "Listed";
  }
  if (normalized === "accepted") {
    return "Offer accepted";
  }
  if (normalized === "rejected") {
    return "Offer rejected";
  }
  return status;
};
